/** Walk plan-ordered instructions; map step `id` / `stepId` → 1-based step number for binding pills. */
export function buildUuidToDisplayStepNumberMap(instructions) {
    const map = new Map();
    let flat = 0;
    for (const inst of (instructions || []).filter((i) => i.aiSteps?.length)) {
        for (const step of inst.aiSteps || []) {
            const zeroBased =
                step?.stepIndex != null && Number.isFinite(Number(step.stepIndex))
                    ? Number(step.stepIndex)
                    : flat;
            const n = zeroBased + 1;
            for (const raw of [step?.stepId, step?.id]) {
                const k = raw != null && String(raw).trim() !== "" ? String(raw).trim().toLowerCase() : "";
                if (k && !map.has(k)) map.set(k, n);
            }
            flat += 1;
        }
    }
    return map;
}

/** `bag.stepId.<uuid>.*` → display step number; unknown uuid → ''; else trimmed placeholder. */
export function bindingPlaceholderDisplay(placeholder, uuidToDisplayStep) {
    const s = String(placeholder ?? "").trim();
    if (!s) return "";
    const m = s.match(/bag\.stepId\.([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i);
    if (!m) return s;
    const uuid = m[1].toLowerCase();
    return uuidToDisplayStep.has(uuid) ? `Step ${uuidToDisplayStep.get(uuid)}` : "";
}


